import React from "react";
import { SERVICES } from "@/lib/content";
import {
    Anchor,
    AlignHorizontalDistributeCenter,
    Sparkles,
    Waves,
    Sun,
    Baby,
    Scissors,
    ShieldCheck,
    Crown,
    ScanLine,
    ArrowUpRight,
} from "lucide-react";

const ICONS = {
    Anchor,
    AlignHorizontalDistributeCenter,
    Sparkles,
    Waves,
    Sun,
    Baby,
    Scissors,
    ShieldCheck,
    Crown,
    ScanLine,
};

export default function Services({ onBook }) {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="py-24 md:py-32"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] text-[#7a8582] flex items-center">
                            <span className="gdc-divider" />
                            Services
                        </div>
                        <h2 className="font-serif-display mt-4 text-4xl md:text-5xl leading-tight text-[#1a1d1c] max-w-2xl">
                            Every treatment, thoughtfully{" "}
                            <span className="italic text-[#114b5f]">
                                crafted.
                            </span>
                        </h2>
                    </div>
                    <p className="text-[#4a5250] max-w-md">
                        From routine hygiene to full-mouth rehabilitations —
                        eight areas of expertise, one meticulous studio.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {SERVICES.map((s) => {
                        const Icon = ICONS[s.icon] || Sparkles;
                        return (
                            <button
                                key={s.id}
                                type="button"
                                onClick={() => onBook?.(s.title)}
                                data-testid={`service-card-${s.id}`}
                                className="group text-left bg-[#f3f0ea] p-7 rounded-3xl transition-all hover:-translate-y-2 hover:shadow-xl border border-transparent hover:border-[#8fa998]/40 flex flex-col h-full"
                            >
                                <div className="h-12 w-12 rounded-2xl bg-white flex items-center justify-center mb-6">
                                    <Icon
                                        size={22}
                                        strokeWidth={1.5}
                                        className="text-[#114b5f]"
                                    />
                                </div>
                                <h3 className="font-serif-display text-xl md:text-2xl text-[#1a1d1c] leading-tight">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-sm text-[#4a5250] leading-relaxed flex-1">
                                    {s.description}
                                </p>
                                <span className="mt-6 inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em] text-[#114b5f] group-hover:text-[#0d3a4a]">
                                    Book this
                                    <ArrowUpRight
                                        size={14}
                                        strokeWidth={1.5}
                                        className="transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                    />
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
